"use client";

import { ArrowUpRight, Copy, MapPin, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DirectLine() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const hours = [{
    day: "MON",
    time: "08:00 — 17:00"
  }, {
    day: "TUE",
    time: "08:00 — 17:00"
  }, {
    day: "WED",
    time: "08:00 — 17:00"
  }, {
    day: "THU",
    time: "08:00 — 17:00"
  }, {
    day: "FRI",
    time: "08:00 — 17:00"
  }, {
    day: "SAT",
    time: "09:00 — 13:00"
  }, {
    day: "SUN",
    time: "CLOSED"
  }];
  return <section data-section-id="3092" id="direct-line" className="dark bg-background text-foreground relative overflow-hidden">
      <div className="flex flex-col lg:flex-row">
        {}
        <div ref={leftRef} className={`relative w-full lg:w-3/5 h-[50vh] lg:h-[70vh] overflow-hidden transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"}`}>
          {}
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundColor: "hsl(190 40% 12%)",
          backgroundImage: "radial-gradient(ellipse at 50% 50%, hsla(22, 90%, 55%, 0.08) 0%, transparent 60%)"
        }} aria-hidden="true" />

          {}
          <div className="absolute inset-0 pointer-events-none" style={{
          backgroundImage: "linear-gradient(hsla(210, 10%, 45%, 0.04) 1px, transparent 1px), linear-gradient(90deg, hsla(210, 10%, 45%, 0.04) 1px, transparent 1px)",
          backgroundSize: "48px 48px"
        }} aria-hidden="true" />

          {}
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 800 600" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            {}
            <g stroke="hsl(190 30% 24%)" strokeWidth="2.5" fill="none" strokeLinecap="round">
              <path d="M0,200 L300,200 L350,250 L500,250 L550,300 L800,300" />
              <path d="M150,0 L150,180 L200,230 L200,400 L250,450 L250,600" />
              <path d="M0,450 L180,450 L230,400 L450,400 L500,450 L800,450" />
              <path d="M450,0 L450,180 L500,230 L500,380 L550,430 L600,430 L600,600" />
              <path d="M650,0 L650,150 L700,200 L700,500 L650,550 L650,600" />
            </g>

            {}
            <g stroke="hsl(190 30% 20%)" strokeWidth="1" fill="none" strokeLinecap="round">
              <path d="M0,100 L200,100 L250,150 L800,150" />
              <path d="M0,350 L150,350 L200,300 L800,300" />
              <path d="M0,550 L800,550" />
              <path d="M350,0 L350,600" />
              <path d="M550,0 L550,600" />
            </g>

            {}
            <path d="M150,200 L300,200 L350,250 L500,250 L550,300 L600,300" stroke="hsl(22 85% 60%)" strokeWidth="2" fill="none" strokeDasharray="6 4" opacity="0.7" />

            {}
            <g transform="translate(550, 300)">
              <circle r="28" fill="hsl(22 85% 60%)" opacity="0.15">
                <animate attributeName="r" values="20;40;20" dur="3s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.4;0.05;0.4" dur="3s" repeatCount="indefinite" />
              </circle>
              <circle r="14" fill="none" stroke="hsl(22 85% 60%)" strokeWidth="1" opacity="0.6">
                <animate attributeName="r" values="14;22;14" dur="3s" repeatCount="indefinite" />
              </circle>
              {}
              <circle r="6" fill="hsl(190 40% 12%)" stroke="hsl(22 85% 60%)" strokeWidth="1.5" />
              <circle r="2" fill="hsl(22 85% 60%)" />
            </g>

            {}
            <g fill="hsl(0 0% 98%)" fillOpacity="0.55" fontFamily="JetBrains Mono, monospace" fontSize="9" letterSpacing="0.1em">
              <text x="170" y="195" textAnchor="start">
                PROJECT AREA
              </text>
              <text x="260" y="440" textAnchor="start">
                SERVICE ZONE
              </text>
              <text x="560" y="290" textAnchor="start" fill="hsl(22 85% 60%)" fillOpacity="0.9">
                HQ · 2024
              </text>
              <text x="660" y="140" textAnchor="start">
                SITE
              </text>
              <text x="20" y="445" textAnchor="start">
                DISTRICT
              </text>
            </g>

            {}
            <g transform="translate(60, 60)" opacity="0.5">
              <circle r="22" fill="none" stroke="hsl(0 0% 98%)" strokeWidth="0.5" />
              <path d="M0,-18 L4,0 L0,18 L-4,0 Z" fill="hsl(22 85% 60%)" />
              <text y="-26" textAnchor="middle" fill="hsl(0 0% 98%)" fontFamily="JetBrains Mono, monospace" fontSize="9" letterSpacing="0.2em">
                N
              </text>
            </g>

            {}
            <g transform="translate(40, 540)" fill="hsl(0 0% 98%)" fillOpacity="0.5" fontFamily="JetBrains Mono, monospace" fontSize="8" letterSpacing="0.15em">
              <line x1="0" y1="0" x2="80" y2="0" stroke="hsl(0 0% 98%)" strokeOpacity="0.5" strokeWidth="1" />
              <line x1="0" y1="-3" x2="0" y2="3" stroke="hsl(0 0% 98%)" strokeOpacity="0.5" strokeWidth="1" />
              <line x1="80" y1="-3" x2="80" y2="3" stroke="hsl(0 0% 98%)" strokeOpacity="0.5" strokeWidth="1" />
              <text x="40" y="16" textAnchor="middle">
                1 KM
              </text>
            </g>
          </svg>

          {}
          <div className="absolute top-6 right-6 font-mono text-[10px] tracking-[0.2em] text-foreground/50 text-right">
            <div>34°05′12″N</div>
            <div>118°14′37″W</div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative w-full lg:w-2/5 bg-card text-card-foreground transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"}`} style={{
        padding: "clamp(2rem, 5vw, 5rem)"
      }}>
          <div className="flex flex-col h-full">
            {}
            <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-muted-foreground mb-6">
              — Elite Brushstrokes
            </div>

            {}
            <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-foreground">
              Precision
              <br />
              <span className="italic text-primary">Painting.</span>
            </h2>

            {}
            <div className="mt-6 mb-10 w-16 h-px bg-primary" />

            {}
            <div className="space-y-2">
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground flex items-center gap-2">
                <MapPin className="h-3 w-3" /> Headquarters
              </div>
              <address className="not-italic font-serif text-[20px] leading-relaxed text-foreground">
                124 Artisan Way
                <br />
                Los Angeles, CA 90012
                <br />
                United States
              </address>
              <Link to="/GetAQuotePage" className="inline-flex items-center gap-1.5 font-mono text-[11px] tracking-[0.2em] uppercase text-muted-foreground hover:text-primary transition-colors group mt-2">
                Get Directions
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </div>

            <Separator className="my-8 bg-border" />

            {}
            <div className="space-y-4">
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
                Operational Hours
              </div>
              <div className="font-mono text-[12px] tracking-[0.05em]">
                {hours.map((h, i) => <div data-index={i} key={h.day} className="flex justify-between items-baseline py-1.5 border-b border-border/50 last:border-b-0">
                    <span className="text-foreground/80">{h.day}</span>
                    <span className={h.time === "CLOSED" ? "text-muted-foreground/60" : "text-foreground"}>
                      {h.time}
                    </span>
                  </div>)}
              </div>
              <div className="inline-block mt-3 px-3 py-1.5 border border-primary/60 text-primary font-mono text-[10px] tracking-[0.3em] uppercase">
                Consultations Available
              </div>
            </div>

            <Separator className="my-8 bg-border" />

            {}
            <div className="space-y-4">
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
                Contact
              </div>
              <div className="space-y-3">
                <div className="flex items-center justify-between gap-4 group">
                  <div className="flex items-center gap-3 font-mono text-[13px] text-foreground">
                    <Phone className="h-3.5 w-3.5 text-primary" />
                    (555) 824-9900
                  </div>
                  <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-primary hover:bg-transparent" aria-label="Copy phone number">
                    <Copy className="h-3.5 w-3.5" />
                  </Button>
                </div>
                <div className="flex items-center justify-between gap-4 group">
                  <div className="flex items-center gap-3 font-mono text-[13px] text-foreground">
                    <Mail className="h-3.5 w-3.5 text-primary" />
                    hello@elitebrushstrokes.com
                  </div>
                  <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-primary hover:bg-transparent" aria-label="Copy email">
                    <Copy className="h-3.5 w-3.5" />
                  </Button>
                </div>
              </div>
            </div>

            {}
            <div className="mt-10 mb-8 pl-5 border-l border-primary/60">
              <p className="font-serif italic text-[17px] leading-relaxed text-foreground/85">
                "Every wall is a canvas, and every stroke is a commitment to
                architectural perfection."
              </p>
            </div>

            {}
            <Link to="/GalleryPage" className="relative block mt-auto overflow-hidden rounded-md group" aria-label="View our project gallery">
              <div className="relative aspect-[16/8] overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/painter_at_work_residential.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/painter_at_work_residential.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/painter_at_work_residential.png-wvc-sizes" alt="Professional painter working on a residential project" loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-background/55 group-hover:bg-background/35 transition-colors duration-500" />
                <div className="absolute inset-0 flex items-center justify-between px-6">
                  <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-foreground">
                    View Gallery
                  </span>
                  <span className="flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase text-primary">
                    Est. 2012
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}